import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import MensajeCargando from '../../UI/MensajeCargando.js';
import MensajeError from '../../UI/MensajeError.js';
import ElegirFechaEtapa from './ElegirFechaEtapa.js';
import PartidosEquipoTorneo from '../../tablas/PartidosEquipoTorneo.js';
import PartidosEtapaTorneo from '../../tablas/PartidosEtapaTorneo.js';
import PartidosFechaEtapa from '../../tablas/PartidosFechaEtapa.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import { Partidos as TipoLista } from '../../constantes/Filtros.js';
import * as Funciones from '../../funciones/FuncionesTorneos.js';

const ListaPartidos = (props) => {
  const tipoLista = props.tipoLista;
  const datosElegidos = props.datosElegidos;
  const [partidos, setPartidos] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  const url = useMemo(() => {
    return Funciones.URLListaPartidos(tipoLista, datosElegidos);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoLista, datosElegidos.torneo, datosElegidos.etapa, datosElegidos.equipo]);

  useEffect(() => {
    if (url) {
      fetchData(url, setPartidos);
    } else {
      setPartidos([]);
    }
  }, [url, fetchData]);

  // Reset fecha when etapa changes
  useEffect(() => {
    setFechaSeleccionada(null);
  }, [datosElegidos.etapa]);

  const navigate = useNavigate();
  const onPartidoElegido = (idPartido) => {
    navigate('/partido/' + idPartido, { state: { datosElegidos } });
  };

  const onFechaElegida = (fecha) => {
    setFechaSeleccionada(fecha);
  };

  // Verificar si la etapa tiene fechas
  const etapaTieneFechas = datosElegidos.etapa && datosElegidos.etapa.cantidadFechas > 0;

  let lista = '';
  switch (tipoLista) {
    case TipoLista.EQUIPO: {
      lista = (
        <PartidosEquipoTorneo
          categoria={datosElegidos.categoria}
          equipo={datosElegidos.equipo}
          partidos={partidos}
          onPartidoElegido={onPartidoElegido}
        />
      );
      break;
    }
    case TipoLista.ETAPA: {
      // Si la etapa tiene fechas, mostrar selector de fechas y filtrar partidos
      if (etapaTieneFechas) {
        lista = (
          <React.Fragment>
            <ElegirFechaEtapa
              etapa={datosElegidos.etapa}
              fechaElegida={fechaSeleccionada}
              onFechaElegida={onFechaElegida}
            />
            <PartidosFechaEtapa
              fecha={fechaSeleccionada}
              partidos={partidos}
              categoria={datosElegidos.categoria}
              onPartidoElegido={onPartidoElegido}
            />
          </React.Fragment>
        );
      } else {
        // Si no tiene fechas, mostrar todos los partidos de la etapa
        lista = (
          <PartidosEtapaTorneo
            etapa={datosElegidos.etapa}
            categoria={datosElegidos.categoria}
            partidos={partidos}
            onPartidoElegido={onPartidoElegido}
          />
        );
      }
      break;
    }
    case TipoLista.FECHAS_ETAPA: {
      lista = (
        <React.Fragment>
          <ElegirFechaEtapa
            etapa={datosElegidos.etapa}
            fechaElegida={fechaSeleccionada}
            onFechaElegida={onFechaElegida}
          />
          <PartidosFechaEtapa
            fecha={fechaSeleccionada}
            partidos={partidos}
            categoria={datosElegidos.categoria}
            onPartidoElegido={onPartidoElegido}
          />
        </React.Fragment>
      );
      break;
    }
    default: {
      throw new Error('Tipo de lista desconocido');
    }
  }

  return (
    <React.Fragment>
      {!isCargando && lista}
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default ListaPartidos;
